enum SellEnum {
  // Trustpilot
  'trustpilot.label' = 'trustpilot.label',
  'trustpilot.subtitle' = 'trustpilot.subtitle',

  // Hero section
  'hero.title_highlight' = 'hero.title_highlight',
  'hero.title_main' = 'hero.title_main',
  'hero.subtitle' = 'hero.subtitle',
  'hero.cta_button' = 'hero.cta_button',

  // Section 2
  'section2.title' = 'section2.title',
  'section2.highlight' = 'section2.highlight',

  // Book banner note
  'book_banner.title' = 'book_banner.title',
  'book_banner.highlight' = 'book_banner.highlight',

  // Section 3
  'section3.title' = 'section3.title',
  'section3.subtitle' = 'section3.subtitle',
  'section3.service.default.title' = 'section3.service.default.title',
  'section3.service.default.description' = 'section3.service.default.description',
  'section3.service.default.benefits.benefit1' = 'section3.service.default.benefits.benefit1',
  'section3.service.default.benefits.benefit2' = 'section3.service.default.benefits.benefit2',
  'section3.service.default.benefits.benefit3' = 'section3.service.default.benefits.benefit3',
  'section3.service.default.benefits.benefit4' = 'section3.service.default.benefits.benefit4',
  'section3.service.default.button' = 'section3.service.default.button',
  'section3.service.default.secondary_link' = 'section3.service.default.secondary_link',
  'section3.service.recommended.title' = 'section3.service.recommended.title',
  'section3.service.recommended.description' = 'section3.service.recommended.description',
  'section3.service.recommended.benefits.benefit1' = 'section3.service.recommended.benefits.benefit1',
  'section3.service.recommended.benefits.benefit2' = 'section3.service.recommended.benefits.benefit2',
  'section3.service.recommended.benefits.benefit3' = 'section3.service.recommended.benefits.benefit3',
  'section3.service.recommended.benefits.benefit4' = 'section3.service.recommended.benefits.benefit4',
  'section3.service.recommended.button' = 'section3.service.recommended.button',
  'section3.service.recommended.secondary_link' = 'section3.service.recommended.secondary_link',
  'section3.trust_text' = 'section3.trust_text',
  'section3.trustpilot' = 'section3.trustpilot',

  // Section 4
  'section4.label' = 'section4.label',
  'section4.stats.stat1.value' = 'section4.stats.stat1.value',
  'section4.stats.stat1.label' = 'section4.stats.stat1.label',
  'section4.stats.stat2.value' = 'section4.stats.stat2.value',
  'section4.stats.stat2.label' = 'section4.stats.stat2.label',
  'section4.stats.stat3.value' = 'section4.stats.stat3.value',
  'section4.stats.stat3.label' = 'section4.stats.stat3.label',
  'section4.stats.stat4.value' = 'section4.stats.stat4.value',
  'section4.stats.stat4.label' = 'section4.stats.stat4.label',
  'section4.title_prefix' = 'section4.title_prefix',
  'section4.title_highlight' = 'section4.title_highlight',
  'section4.description' = 'section4.description',
  'section4.overlay.free_label' = 'section4.overlay.free_label',
  'section4.overlay.free_text' = 'section4.overlay.free_text',
  'section4.overlay.commission_label' = 'section4.overlay.commission_label',
  'section4.overlay.commission_text' = 'section4.overlay.commission_text',
  'section4.steps.step1.title' = 'section4.steps.step1.title',
  'section4.steps.step1.description' = 'section4.steps.step1.description',
  'section4.steps.step2.title' = 'section4.steps.step2.title',
  'section4.steps.step2.description' = 'section4.steps.step2.description',
  'section4.steps.step3.title' = 'section4.steps.step3.title',
  'section4.steps.step3.description' = 'section4.steps.step3.description',
  'section4.steps.step4.title' = 'section4.steps.step4.title',
  'section4.steps.step4.description' = 'section4.steps.step4.description',
  'section4.cta_button' = 'section4.cta_button',
  'section4.cta_subtext' = 'section4.cta_subtext',

  // Section 5
  'section5.badge' = 'section5.badge',
  'section5.title_main' = 'section5.title_main',
  'section5.title_highlight' = 'section5.title_highlight',
  'section5.subtitle' = 'section5.subtitle',
  'section5.steps.step1.title' = 'section5.steps.step1.title',
  'section5.steps.step1.description' = 'section5.steps.step1.description',
  'section5.steps.step2.title' = 'section5.steps.step2.title',
  'section5.steps.step2.description' = 'section5.steps.step2.description',
  'section5.steps.step3.title' = 'section5.steps.step3.title',
  'section5.steps.step3.description' = 'section5.steps.step3.description',
  'section5.steps.step4.title' = 'section5.steps.step4.title',
  'section5.steps.step4.description' = 'section5.steps.step4.description',
  'section5.overlay.allround_service' = 'section5.overlay.allround_service',
  'section5.overlay.no_hassle' = 'section5.overlay.no_hassle',
  'section5.overlay.satisfied_sellers' = 'section5.overlay.satisfied_sellers',
  'section5.overlay.seller_count' = 'section5.overlay.seller_count',
  'section5.cta_button' = 'section5.cta_button',
  'section5.cta_subtext' = 'section5.cta_subtext',

  // Section 6
  'section6.title' = 'section6.title',
  'section6.subtitle' = 'section6.subtitle',
  'section6.benefits.benefit1.title' = 'section6.benefits.benefit1.title',
  'section6.benefits.benefit1.description' = 'section6.benefits.benefit1.description',
  'section6.benefits.benefit2.title' = 'section6.benefits.benefit2.title',
  'section6.benefits.benefit2.description' = 'section6.benefits.benefit2.description',
  'section6.benefits.benefit3.title' = 'section6.benefits.benefit3.title',
  'section6.benefits.benefit3.description' = 'section6.benefits.benefit3.description',
  'section6.benefits.benefit4.title' = 'section6.benefits.benefit4.title',
  'section6.benefits.benefit4.description' = 'section6.benefits.benefit4.description',
  'section6.security.title' = 'section6.security.title',
  'section6.security.subtitle' = 'section6.security.subtitle',
  'section6.security.cards.card1.title' = 'section6.security.cards.card1.title',
  'section6.security.cards.card1.description' = 'section6.security.cards.card1.description',
  'section6.security.cards.card2.title' = 'section6.security.cards.card2.title',
  'section6.security.cards.card2.description' = 'section6.security.cards.card2.description',
  'section6.security.cards.card3.title' = 'section6.security.cards.card3.title',
  'section6.security.cards.card3.description' = 'section6.security.cards.card3.description',
  'section6.security.link' = 'section6.security.link',
  'section6.testimonials.headline' = 'section6.testimonials.headline',
  'section6.testimonials.title' = 'section6.testimonials.title',
  'section6.testimonials.cards.card1.title' = 'section6.testimonials.cards.card1.title',
  'section6.testimonials.cards.card1.text' = 'section6.testimonials.cards.card1.text',
  'section6.testimonials.cards.card1.author' = 'section6.testimonials.cards.card1.author',
  'section6.testimonials.cards.card1.role' = 'section6.testimonials.cards.card1.role',
  'section6.testimonials.cards.card2.title' = 'section6.testimonials.cards.card2.title',
  'section6.testimonials.cards.card2.text' = 'section6.testimonials.cards.card2.text',
  'section6.testimonials.cards.card2.author' = 'section6.testimonials.cards.card2.author',
  'section6.testimonials.cards.card2.role' = 'section6.testimonials.cards.card2.role',
  'section6.testimonials.cards.card3.title' = 'section6.testimonials.cards.card3.title',
  'section6.testimonials.cards.card3.text' = 'section6.testimonials.cards.card3.text',
  'section6.testimonials.cards.card3.author' = 'section6.testimonials.cards.card3.author',
  'section6.testimonials.cards.card3.role' = 'section6.testimonials.cards.card3.role',
  'section6.testimonials.rating' = 'section6.testimonials.rating',
  'section6.testimonials.rating_subtitle' = 'section6.testimonials.rating_subtitle',
  'section6.faq.title' = 'section6.faq.title',
  'section6.faq.items.item1.question' = 'section6.faq.items.item1.question',
  'section6.faq.items.item1.answer' = 'section6.faq.items.item1.answer',
  'section6.faq.items.item2.question' = 'section6.faq.items.item2.question',
  'section6.faq.items.item2.answer' = 'section6.faq.items.item2.answer',
  'section6.faq.items.item3.question' = 'section6.faq.items.item3.question',
  'section6.faq.items.item3.answer' = 'section6.faq.items.item3.answer',
  'section6.faq.items.item4.question' = 'section6.faq.items.item4.question',
  'section6.faq.items.item4.answer' = 'section6.faq.items.item4.answer',
  'section6.faq.items.item5.question' = 'section6.faq.items.item5.question',
  'section6.faq.items.item5.answer' = 'section6.faq.items.item5.answer',
  'section6.faq.items.item6.question' = 'section6.faq.items.item6.question',
  'section6.faq.items.item6.answer' = 'section6.faq.items.item6.answer',
  'section6.faq.items.item7.question' = 'section6.faq.items.item7.question',
  'section6.faq.items.item7.answer' = 'section6.faq.items.item7.answer',
  'section6.faq.items.item8.question' = 'section6.faq.items.item8.question',
  'section6.faq.items.item8.answer' = 'section6.faq.items.item8.answer',
  'section6.faq.items.item9.question' = 'section6.faq.items.item9.question',
  'section6.faq.items.item9.answer' = 'section6.faq.items.item9.answer',
  'section6.faq.items.item10.question' = 'section6.faq.items.item10.question',
  'section6.faq.items.item10.answer' = 'section6.faq.items.item10.answer',
  'section6.faq.items.item11.question' = 'section6.faq.items.item11.question',
  'section6.faq.items.item11.answer' = 'section6.faq.items.item11.answer',

  // Section 8
  'section8.label' = 'section8.label',
  'section8.title' = 'section8.title',
  'section8.bullet' = 'section8.bullet',
  'section8.button_mobile' = 'section8.button_mobile',
  'section8.button_desktop' = 'section8.button_desktop',

  // Mobile Steps
  'mobile_steps.title' = 'mobile_steps.title',
  'mobile_steps.tab_self' = 'mobile_steps.tab_self',
  'mobile_steps.tab_commission' = 'mobile_steps.tab_commission',

  // Alt texts
  'alt_texts.selling_whisky_book' = 'alt_texts.selling_whisky_book',
  'alt_texts.holding_whisky_bottle' = 'alt_texts.holding_whisky_bottle',
  'alt_texts.spiritory_service' = 'alt_texts.spiritory_service',

  // Decision
  'decision.title' = 'decision.title',
  'decision.subtitle' = 'decision.subtitle',
  'decision.buttonLeft' = 'decision.buttonLeft',
  'decision.buttonRight' = 'decision.buttonRight',
  'decision.infoLine1' = 'decision.infoLine1',
  'decision.infoLine2' = 'decision.infoLine2',

  // By Yourself Page
  'by_yourself_page.metadata.title' = 'by_yourself_page.metadata.title',
  'by_yourself_page.metadata.description' = 'by_yourself_page.metadata.description',
  'by_yourself_page.hero.title' = 'by_yourself_page.hero.title',
  'by_yourself_page.hero.subtitle' = 'by_yourself_page.hero.subtitle',
  'by_yourself_page.steps.1.title' = 'by_yourself_page.steps.1.title',
  'by_yourself_page.steps.1.description' = 'by_yourself_page.steps.1.description',
  'by_yourself_page.steps.2.title' = 'by_yourself_page.steps.2.title',
  'by_yourself_page.steps.2.description' = 'by_yourself_page.steps.2.description',
  'by_yourself_page.steps.3.title' = 'by_yourself_page.steps.3.title',
  'by_yourself_page.steps.3.description' = 'by_yourself_page.steps.3.description',
  'by_yourself_page.steps.3.link_auth' = 'by_yourself_page.steps.3.link_auth',
  'by_yourself_page.steps.3.link_shipping' = 'by_yourself_page.steps.3.link_shipping',
  'by_yourself_page.steps.4.title' = 'by_yourself_page.steps.4.title',
  'by_yourself_page.steps.4.description' = 'by_yourself_page.steps.4.description',
  'by_yourself_page.search.title' = 'by_yourself_page.search.title',
  'by_yourself_page.search.description' = 'by_yourself_page.search.description',
  'by_yourself_page.search.placeholder' = 'by_yourself_page.search.placeholder',
  'by_yourself_page.search.fees_info' = 'by_yourself_page.search.fees_info',

  'contact_modal.step1_title' = 'contact_modal.step1_title',
  'contact_modal.step1_subtitle' = 'contact_modal.step1_subtitle',
  'contact_modal.step1_desc' = 'contact_modal.step1_desc',
  'contact_modal.step2_title' = 'contact_modal.step2_title',
  'contact_modal.step2_subtitle' = 'contact_modal.step2_subtitle',
  'contact_modal.first_name' = 'contact_modal.first_name',
  'contact_modal.last_name' = 'contact_modal.last_name',
  'contact_modal.email' = 'contact_modal.email',
  'contact_modal.phone' = 'contact_modal.phone',
  'contact_modal.phone_hint' = 'contact_modal.phone_hint',
  'contact_modal.error_required' = 'contact_modal.error_required',
  'contact_modal.error_email' = 'contact_modal.error_email',
  'contact_modal.error_bottles' = 'contact_modal.error_bottles',
  'contact_modal.bottles_count' = 'contact_modal.bottles_count',
  'contact_modal.bottles_hint' = 'contact_modal.bottles_hint',
  'contact_modal.file_upload' = 'contact_modal.file_upload',
  'contact_modal.file_hint' = 'contact_modal.file_hint',
  'contact_modal.file_select' = 'contact_modal.file_select',
  'contact_modal.file_none' = 'contact_modal.file_none',
  'contact_modal.file_selected_one' = 'contact_modal.file_selected_one',
  'contact_modal.file_selected_many' = 'contact_modal.file_selected_many',
  'contact_modal.error_file_size' = 'contact_modal.error_file_size',
  'contact_modal.additional_info' = 'contact_modal.additional_info',
  'contact_modal.additional_placeholder' = 'contact_modal.additional_placeholder',
  'contact_modal.btn_next' = 'contact_modal.btn_next',
  'contact_modal.btn_back' = 'contact_modal.btn_back',
  'contact_modal.btn_submit' = 'contact_modal.btn_submit',
  'contact_modal.btn_submitting' = 'contact_modal.btn_submitting',
  'contact_modal.btn_close' = 'contact_modal.btn_close',
  'contact_modal.success_title' = 'contact_modal.success_title',
  'contact_modal.success_desc' = 'contact_modal.success_desc',
  'contact_modal.error_submit' = 'contact_modal.error_submit',
}

export default SellEnum;
